import { useEffect, useState } from "react";
import { cn } from "@/utils/string.ts";
import { useMe } from "@/data/user.ts";
import { useModalAction } from "@/contexts/modal/Context.tsx";
import { useCreateFeedbackRatingMutation } from "@/data/feedback.ts";
import Button from "@edusogno/primitives/button";
import Textarea from "@edusogno/primitives/textarea";

export default function FeedbackRatingModal() {
  const [rating, setRating] = useState<number | null>(null);
  const { me } = useMe();
  const { closeModal } = useModalAction();
  const [step, setStep] = useState(0);
  const [comment, setComment] = useState("");

  const { mutate } = useCreateFeedbackRatingMutation(() => {
    setStep(3);
    setTimeout(() => {
      closeModal();
    }, 2000);
  });

  const handleSend = () => {
    if (!rating || !me) return;

    mutate({
      nps_comment: comment,
      nps_feedback: rating,
      token: me.item.user.token,
    });
  };

  useEffect(() => {
    if (!rating) return;

    if (rating < 9 && rating > 5) {
      setStep(1);
    } else if (rating < 6) {
      setStep(2);
    } else {
      handleSend();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rating]);

  const handleBackClick = () => {
    setStep(0);
    setComment("");
  };

  return (
    <div className="flex flex-col items-stretch justify-between h-full gap-4">
      <div className={"flex flex-grow gap-x-8 items-center"}>
        {step === 0 && (
          <>
            <p className="text-[#2D224C] lg:text-[20px] text-[12px] text-start lg:font-semibold  w-full">
              How likely are you to recommend us to a friend? 🙏
            </p>
            <div className={"h-full w-full  flex flex-col  justify-evenly"}>
              <div className="w-full grid grid-cols-11  gap-2 items-center">
                {Array.from({ length: 11 }).map((_, r) => (
                  <Button
                    key={"key" + r}
                    className={cn(
                      "flex items-center lg:text-[20px] text-[12px] justify-center aspect-square border border-brand bg-white rounded-full font-semibold",
                      {
                        "bg-brand": rating && r <= rating,
                        "text-white": rating && r <= rating,
                      },
                    )}
                    onClick={() => setRating(() => r)}
                  >
                    {r}
                  </Button>
                ))}
              </div>
              <div className="flex flex-row justify-between w-full items-end h-fit ">
                <p className="text-[#2D224C] text-[12px] font-regular">
                  Not at all recommended
                </p>
                <p className="text-[#2D224C] text-[12px] font-regular">
                  Very recommended
                </p>
              </div>
            </div>
          </>
        )}
        {(step === 1 || step === 2) && (
          <>
            <p className="text-[#2D224C] lg:text-[20px] text-[12px] text-start lg:font-semibold  w-full">
              {step === 1
                ? "What are  we missing to get 9 or 10?"
                : " Why such a low number? Tell us honestly what we need to improve"}
            </p>

            <div
              className={
                "grid grid-cols-[auto_255px] w-full items-center gap-4"
              }
            >
              <Textarea
                placeholder="Write a comment here..."
                onChange={(event) => {
                  setComment(event.target.value);
                }}
              />
              <div className={"flex flex-col gap-2"}>
                <Button
                  size={"md"}
                  variant="contained"
                  onClick={handleBackClick}
                >
                  Back
                </Button>
                <Button
                  size={"md"}
                  disabled={!comment}
                  variant="contained"
                  onClick={handleSend}
                >
                  Send
                </Button>
              </div>
            </div>
          </>
        )}

        {step === 3 && (
          <p className="text-[#2D224C] lg:text-[20px] text-[14px]  text-center lg:font-semibold  w-full">
            Thank you for your feedback 🙌
          </p>
        )}
      </div>
    </div>
  );
}
